import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

const mobileCss = css(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.background};
        border-radius: ${radius[8]}px;
        margin-bottom: 28px;
        padding: 24px 24px 24px 28px;
    `,
);

export const ProfileDataWrapper = styled.div<{ isMobile?: boolean }>(
    ({ isMobile }) => css`
        margin-bottom: 24px;
        padding-left: 4px;

        ${isMobile && mobileCss}
    `,
);

export const EmailInfo = styled.div`
    display: flex;
    align-items: center;
`;

export const CompanyInfo = styled(Typography.TextBody_14_20)<{
    isMobile?: boolean;
}>(
    ({ isMobile }) => css`
        margin: ${isMobile ? '4px 0 0 44px' : '4px 0 0 36px'};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    `,
);

export const StyledIcon = styled(IconManager)<{ isMobile?: boolean }>(
    ({ isMobile }) => css`
        margin-right: ${isMobile ? '20px' : '12px'};
    `,
);

export const Email = styled(Typography.TextBody_16_24)(
    ({ theme: { fontWeight } }) => css`
        font-weight: ${fontWeight.bold};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    `,
);
